module.exports = __webpack_public_path__ + "images/3b35367aa6de36c582e7ed08a2ea520f.svg";